<template>
  <div>
    <poppins-popup v-model="showUnsavedChangesPopup" popup-header="Unsaved changes">
      <p class="text-body mb-16">If you leave your changes will not be saved</p>
      <poppins-button value="Discard" size="medium" variant="primary" class="w-full" @click="confirmDiscard" />
    </poppins-popup>
    <poppins-card class="w-full max-w-448 mx-auto px-16 py-24 md:px-24 mb-24">
      <poppins-breadcrumb
        v-if="breadcrumbLabel"
        :header="breadcrumbLabel"
        is-button
        class="mb-24 !mt-0"
        @click="handleBreadcrumbClick"
      />
      <h1 class="text-h4 mb-24">{{ title }}</h1>
      <slot />
      <div class="flex flex-col gap-8 mt-24">
        <poppins-button
          :loading="saving"
          :disabled="hasInvalidInput"
          class="w-full"
          variant="primary"
          value="Save"
          size="medium"
          type="button"
          @click="$emit('save')"
        />
        <poppins-button class="w-full" variant="text" value="Cancel" size="medium" type="button" @click="handleCancel" />
      </div>
    </poppins-card>
  </div>
</template>

<script lang="ts">
import PoppinsCard from '@/components/card/Card.vue';
import PoppinsBreadcrumb from '@/components/breadcrumb/Breadcrumb.vue';
import PoppinsButton from '@/components/button/Button.vue';
import PoppinsPopup from '@/components/popup/Popup.vue';

export default {
  name: 'ProfileEditSectionCard',
  components: {
    PoppinsCard,
    PoppinsBreadcrumb,
    PoppinsButton,
    PoppinsPopup,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    breadcrumbLabel: {
      type: String,
      default: 'Profile',
    },
    saving: {
      type: Boolean,
      default: false,
    },
    hasUnsavedChanges: {
      type: Boolean,
      default: false,
    },
    hasInvalidInput: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['breadcrumb-click', 'save', 'cancel'],
  data() {
    return {
      showUnsavedChangesPopup: false,
    };
  },
  methods: {
    handleBreadcrumbClick() {
      if (this.hasUnsavedChanges) {
        this.showUnsavedChangesPopup = true;
      } else {
        this.$emit('breadcrumb-click');
      }
    },
    handleCancel() {
      if (this.hasUnsavedChanges) {
        this.showUnsavedChangesPopup = true;
      } else {
        this.$emit('cancel');
      }
    },
    confirmDiscard() {
      this.showUnsavedChangesPopup = false;
      this.$emit('cancel');
    },
  },
};
</script>
